import { render, staticRenderFns } from "./sharing.page.vue?vue&type=template&id=6ce8e0c6&"
import script from "./sharing.page.vue?vue&type=script&lang=js&"
export * from "./sharing.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports